import { render, staticRenderFns } from "./professionalDetail.vue?vue&type=template&id=4e67c8d8&scoped=true&"
import script from "./professionalDetail.vue?vue&type=script&lang=js&"
export * from "./professionalDetail.vue?vue&type=script&lang=js&"
import style0 from "./professionalDetail.vue?vue&type=style&index=0&id=4e67c8d8&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e67c8d8",
  null
  
)

export default component.exports